import { Commune } from "../commune-interface";
import { Box, Typography, Stack, Grid, Tooltip, useTheme, useMediaQuery } from "@mui/material";
import CircularProgressWithLabel from "../shared/CircularProgressWithLabel.component";
import TotalProgress from "../shared/TotalProgress.component";

export default function ScoreBoardComponent({
  communes,
}: {
  communes: Commune[];
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const found = communes.filter((c) => !!c.timeFound);
  const communeByRegion = new Map<string, Commune[]>();
  
  communes.forEach((c) => {
    const coll = communeByRegion.get(c.region);
    if (!!coll) {
      coll.push(c);
    } else {
      communeByRegion.set(c.region, [c]);
    }
  });

  const totalPercentage = communes.length > 0 
    ? ((found.length / communes.length) * 100).toFixed(1)
    : "0.0";
  
  const totalPopulation = communes.reduce((sum, c) => sum + c.population, 0);
  const foundPopulation = found.reduce((sum, c) => sum + c.population, 0);
  const populationPercentage = totalPopulation > 0
    ? ((foundPopulation / totalPopulation) * 100).toFixed(1)
    : "0.0";
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Progression
        </Typography>
        
        {/* Total Progress Bar added here */}
        <TotalProgress communes={communes} />
        
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Tooltip title="Pourcentage des communes trouvées">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  Communes:
                </Typography>
                <Typography variant="body1" fontWeight="bold">
                  {found.length}/{communes.length} ({totalPercentage}%)
                </Typography>
              </Box>
            </Tooltip>
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <Tooltip title="Pourcentage de la population représentée par les communes trouvées">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  Population:
                </Typography>
                <Typography variant="body1" fontWeight="bold">
                  {populationPercentage}%
                </Typography>
              </Box>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
      
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Progression par région
        </Typography>
        
        <Stack
          direction={isMobile ? "column" : "row"}
          justifyContent="space-between"
          spacing={2}
        >
          {Array.from(communeByRegion).map(([region, communeR]) => {
            const regionFoundCount = communeR.filter(c => !!c.timeFound).length;
            const regionPercentage = (regionFoundCount / communeR.length) * 100;
            
            return (
              <Box 
                key={region}
                sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center',
                  p: 1
                }}
              >
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  {region} ({regionFoundCount}/{communeR.length})
                </Typography>
                <CircularProgressWithLabel value={regionPercentage} />
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Box>
  );
}
